import io from 'socket.io-client';

let connection = null;
export default (headers) => {
  if (connection) return connection;
  connection = io(process.env.REACT_APP_BASE_URL, { auth: headers, path: '/sockets/' });
  return connection;
};
